import script from "./MaintenanceForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./MaintenanceForm.vue?vue&type=script&setup=true&lang=ts"

import "./MaintenanceForm.vue?vue&type=style&index=0&id=455b384a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-455b384a"]])

export default __exports__